import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsPopularTripResponse } from "../../Orchestrator/Types/Interface/ICmsPopularTrip";

type Result = IApiResponse<ICmsPopularTripResponse>;

let inFlight: Promise<Result> | null = null;

export async function getCmsPopularTrips(): Promise<Result> {
  // Single-flight: concurrent callers (search step + home flow) share one
  // request so we only hit the network once per page load (clears on settle).
  if (inFlight) return inFlight;

  inFlight = (async () => {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getPopularTripsAPI;

    const params = new URLSearchParams();
    const locale = await getLocaleFromCookie();

    params.append("populate[origin][populate]", "image");
    params.append("populate[destination][populate]", "image");
    params.append("locale", locale);

    const endpointWithParams = `${endpoint}?${params.toString()}`;
    return cmsApiRequest<ICmsPopularTripResponse>(endpointWithParams, "GET");
  })().finally(() => {
    inFlight = null;
  });

  return inFlight;
}
